import { Component, Input, OnChanges } from '@angular/core';
import { Pipe } from '../../../../pumpcalc-core/src/lib/datatypes.service';
import { Keys,Labels } from '../gasflow.constants'
import { UnitsService, FormattingService, Quantity } from 'pumpcalc-core';
import { DxiValueAxisModule } from 'devextreme-angular/ui/nested';
import { until } from 'selenium-webdriver';

@Component({
  selector: 'app-diagram',
  templateUrl: './diagram.component.html',
  styleUrls: ['./diagram.component.css']
})
export class DiagramComponent implements OnChanges {

  @Input()  pipes:Pipe[]=[];
  @Input()  result:any[]=[];
  @Input()  title:string;
  pipeLengthRatio: number;
  keys=Keys;
  labels=Labels;
  totalPipeLength:number;
  canDrawPipe:boolean;
  quantity=Quantity;

  constructor(public unitsService:UnitsService, public formattingService:FormattingService) { }

  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    this.totalPipeLength = 0;
    this.pipes.forEach(pipe => {
      this.totalPipeLength += pipe.length <= 0 ? 0.01 : pipe.length;
    });
    this.pipeLengthRatio = this.totalPipeLength > 0 ? 250 / this.totalPipeLength : 1;
    this.canDrawPipe = this.pipes.length == 0 ? false:true;
    this.pipes.forEach((pipe:Pipe) => {
      if((!pipe.xdim1 || pipe.xdim1 <= 0) && this.pipes.length == 1){this.canDrawPipe = false;}
    })
  }

  startYForPipe(forIndex: number): number {
    let startY = 0;
    for (let i = 0; i < this.pipes.length && i < forIndex; i++) {
      startY += (this.pipes[i].length <= 0 ? 0.01 : this.pipes[i].length) * this.pipeLengthRatio;
    }
    return startY;
  }

  pipeDescription(i){
    return this.pipes[i].section + "\n"
      + (this.pipes[i].section=='Circular' ?
      this.formatNumber(this.unitsService.convertFromSIForQuantity(Quantity.XDIM,this.pipes[i].xdim1)) + this.unitsService.getSelectedUnitForQuantity(Quantity.XDIM) + ' x '
      + this.formatNumber(this.unitsService.convertFromSIForQuantity(Quantity.LENGTH, this.pipes[i].length)) + this.unitsService.getSelectedUnitForQuantity(Quantity.LENGTH)
      : this.formatNumber(this.unitsService.convertFromSIForQuantity(Quantity.XDIM,this.pipes[i].xdim1)) + ' x ' + this.unitsService.convertFromSIForQuantity(Quantity.XDIM,this.pipes[i].xdim2) + this.unitsService.getSelectedUnitForQuantity(Quantity.XDIM)
      + ' x ' + this.formatNumber(this.unitsService.convertFromSIForQuantity(Quantity.LENGTH,this.pipes[i].length)) + this.unitsService.getSelectedUnitForQuantity(Quantity.LENGTH));
  }

  value(forKey,quantity):string {
      return this.result[forKey] ?
      this.formattingService.formatNumber(quantity?this.unitsService.convertFromSIForQuantity(quantity,this.result[forKey].value):this.result[forKey].value)
      : this.result[Labels[forKey]] ?
      this.formattingService.formatNumber(quantity?this.unitsService.convertFromSIForQuantity(quantity,this.result[Labels[forKey]].value):this.result[forKey].value)
      :"";
  }

  valueWithUnit(forKey,quantity):string{
    return this.value(forKey,quantity) + " " + this.unit(quantity);
  }

  unit(quantity):string{
    return this.unitsService.getSelectedUnitForQuantity(quantity);
  }

  formatNumber(number:number){
    return this.formattingService.formatNumber(number);
  }

}
